import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

class Popovers extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      event: (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0)) ? 'click' : ['hover','focus'],
    };
    this.handleTouch = this.handleTouch.bind(this);
  }

  handleTouch() {
    var isTouchDevice =
    (('ontouchstart' in window) ||
    (navigator.maxTouchPoints > 0) ||
    (navigator.msMaxTouchPoints > 0));

    if (isTouchDevice) {
      this.setState({ event: 'click' });
    } else {
      this.setState({ event: ['hover','focus'] });
    }
  }

  componentDidMount() {
    // Handle resize
    window.addEventListener("resize", this.handleTouch);
  }

  render() {
    if (this.props.text !== undefined && this.props.text !== null && this.props.text !== "") {
      return (
        <OverlayTrigger
          placement="auto"
          trigger={this.state.event}
          overlay={
            <Popover id="popover-basic">
              <Popover.Body dangerouslySetInnerHTML={{ __html: this.props.text }} />
            </Popover>
          }
          rootClose
        >
          <img
            src="/themes/custom/unhcr_rw/images/info-grey.svg"
            alt="info"
            className="facet-info"
          />
        </OverlayTrigger>
      );
    }
    return null;
  }
}
export default Popovers;
